import { makeStyles } from '@material-ui/styles';

export default makeStyles({
  main: {
    '& p:first-child': {
      fontWeight: 600,
    },
  },
});
